import { CubeMapTexture } from './CubeMapTexture';
import { Context } from '../context/Context';

export class ImageCubeMapTexture extends CubeMapTexture {
  constructor(public config: TextureSettings) {
    super();
  }

  public async load(ctx: Context): Promise<CubeMapTexture> {
    let gl = ctx.gl;
    let sides = this.getSideMapping(ctx);

    // Load all image data first — each await yields to the event loop, during
    // which the render loop may unbind textures. Do all GL work synchronously
    // after all data is ready.
    let sideData = await Promise.all(
      sides.map(async (side) => ({
        glCubeMapSide: side.glCubeMapSide,
        imageData: await ctx.resourceLoader.loadImageResource(
          `${this.config.sourceDirectory}/${side.reference}.jpg`,
        ),
      })),
    );

    this.glTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.glTexture);

    for (let side of sideData) {
      gl.texImage2D(
        side.glCubeMapSide,
        0,
        gl.RGBA,
        side.imageData.width,
        side.imageData.height,
        0,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        side.imageData.data,
      );
    }

    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
    gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);

    return this;
  }
}

type TextureSettings = {
  sourceDirectory: string;
};
